var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.0740454L1 2.95405C0.45 3.19405 0 4.03404 0 4.75405V9.97404C0 10.694 0.45 11.054 1 10.814L7 7.93404C7.55 7.69404 8 6.85404 8 6.13404V0.914045C8 0.194045 7.55 -0.165955 7 0.0740454ZM7.3 1.63405L4.3 7.21405L0.95 4.51405C0.9 4.45405 0.75 4.27404 0.85 4.09405C0.95 3.85405 1.2 3.97405 1.2 3.97405L4.35 5.35404C4.35 5.35404 6.75 1.57405 6.9 1.33405C6.95 1.21405 7.1 1.15405 7.25 1.27405C7.4 1.39405 7.35 1.57405 7.3 1.63405Z",
    fill: "url(#paint0_linear_758_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_758_7",
    x1: 4,
    y1: 0,
    x2: 4,
    y2: 10.8881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22201"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN3);
export default __webpack_public_path__ + "static/media/n3.33f49dafa69bccb1fd977648cb76f43e.svg";
export { ForwardRef as ReactComponent };